<div class="wrapper">
  <div class="wrapper-content">
    <div class="top"></div>
    <div class="bottom">
      <span class="bottom-content">
        <span>content1</span>
        <span>content2</span>
      </span>
      <span class="bottom-sidebar">
        <span>sidebar1</span>
        <span>sidebar2</span>
        <span>sidebar3</span>
      </span>
    </div>
  </div>
</div>
